<template>
  <NuxtLink noPrefetch to="/publisher"><img src="/assets/img/logo.svg" alt="Логотип" /></NuxtLink>
</template>
